module.exports = __webpack_public_path__ + "img/bt.08fc0df8.png";